import { create } from "zustand";
import {fetchZipInfoByCatGroup, getReviews} from "./api";

export const modalTypes = {
  ENTER_ZIP: "enter_zip",
  UNSERVICED_ZIP: "unserviced_zip",
};

export const useOrderDetail = create((set) => ({
  zip: null,
  client: null,
  modalType: modalTypes.ENTER_ZIP,
  zipInformation: {
    isLoading: false,
    data: null,
  },
  reviews: [],

  updateFields: (fields) => set(fields),
  startOver: () => set({
    zip: null,
    modalType: modalTypes.ENTER_ZIP,
    zipInformation: {
      isLoading: false,
      data: null,
    },
  }),
  getCustomerReviews: async () => {
    const reviewsRes = await getReviews();

    set({
      reviews: reviewsRes,
    });
  },
  getZipInformation: async (zip, externalId, client) => {
    set({
      zipInformation: {
        data: null,
        isLoading: true,
      },
    });

    const zipResponse = await fetchZipInfoByCatGroup(zip, externalId, client);

    if (!zipResponse.isError) {
      set({
        zipInformation: {
          data: zipResponse,
          isLoading: false,
        },
      });
    }

    return zipResponse;
  },
}));
